/** Pix iframe（台帳ビュー）との通信ユーティリティ */

/** kcloud-iframe-done を親ウィンドウに送信して iframe を閉じさせる */
export const notifyParent = () => {
  if (window.self !== window.top) {
    window.parent.postMessage({ type: 'kcloud-iframe-done' }, window.location.origin)
  }
}
